import { requestApi } from "core/api";

export const bookTime = ({ body }) =>
  requestApi({
    path: "/insiders/bookings/",
    method: "POST",
    body
  });

export const fetchSlots = (insiderId, date) =>
  requestApi({
    path: `/insiders/timetable/?insider_id=${insiderId}&date=${date}`,
    method: "GET"
  });

export const fetchAvailableDays = insiderId =>
  requestApi({
    path: `/insiders/timetable/available-days/?insider_id=${insiderId}`,
    method: "GET"
  });



// WEBPACK FOOTER //
// ./src/modules/booking/endpoints.js